import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SaleAction } from '../../store/actions';

class Detail extends PureComponent {
  static propTypes = {
    getSale: PropTypes.func,
    sale: PropTypes.object,
    saleId: PropTypes.number,
  };

  componentDidMount() {
    this.props.getSale(this.props.saleId);
  }

  render() {
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Sale Detail</h3>
            </div>
            <div className="card-body p-0">
              <table className="table table-striped text-nowrap">
                <tbody>
                  <tr>
                    <th>Sold At</th>
                    <td className="text-right">{this.props.sale?.sold_at}</td>
                  </tr>
                  <tr>
                    <th>Customer ID</th>
                    <td className="text-right">
                      {this.props.sale?.customer_id}
                    </td>
                  </tr>
                  <tr>
                    <th>Customer Name</th>
                    <td className="text-right">
                      {this.props.sale?.customer?.name}
                    </td>
                  </tr>
                  <tr>
                    <th>Customer Gender</th>
                    <td className="text-right">
                      {this.props.sale?.customer?.gender}
                    </td>
                  </tr>
                  <tr>
                    <th>Customer Father Name</th>
                    <td className="text-right">
                      {this.props.sale?.customer?.father_name}
                    </td>
                  </tr>
                  <tr>
                    <th>Customer Address</th>
                    <td className="text-right">
                      {this.props.sale?.customer?.address}
                    </td>
                  </tr>
                  <tr>
                    <th>Customer Mobile Number</th>
                    <td className="text-right">
                      {this.props.sale?.customer?.mobile_number}
                    </td>
                  </tr>
                  <tr>
                    <th>Customer Nation ID</th>
                    <td className="text-right">
                      {this.props.sale?.customer?.national_id}
                    </td>
                  </tr>
                  <tr>
                    <th>Chalan Number</th>
                    <td className="text-right">
                      {this.props.sale?.purchase?.chalan_number}
                    </td>
                  </tr>
                  <tr>
                    <th>Model</th>
                    <td className="text-right">
                      {this.props.sale?.purchase?.vehicle?.model}
                    </td>
                  </tr>
                  <tr>
                    <th>Chassis Number</th>
                    <td className="text-right">
                      {this.props.sale?.purchase?.chassis_number}
                    </td>
                  </tr>
                  <tr>
                    <th>Engine Number</th>
                    <td className="text-right">
                      {this.props.sale?.purchase?.engine_number}
                    </td>
                  </tr>
                  <tr>
                    <th>Color</th>
                    <td className="text-right">
                      {this.props.sale?.purchase?.color?.name}
                    </td>
                  </tr>
                  <tr>
                    <th>Price</th>
                    <td className="text-right">{this.props.sale?.price}</td>
                  </tr>
                  <tr>
                    <th>Discount</th>
                    <td className="text-right">{this.props.sale?.discount}</td>
                  </tr>
                  <tr>
                    <th>Total</th>
                    <td className="text-right">{this.props.sale?.total}</td>
                  </tr>
                  <tr>
                    <th>Advance</th>
                    <td className="text-right">{this.props.sale?.advance}</td>
                  </tr>
                  <tr>
                    <th>Initial Due</th>
                    <td className="text-right">
                      {this.props.sale?.initial_due}
                    </td>
                  </tr>
                  <tr>
                    <th>Total Received</th>
                    <td className="text-right">
                      {this.props.sale?.total_received}
                    </td>
                  </tr>
                  {this.props.sale?.installments && !!this.props.sale?.is_due && (
                    <>
                      <tr>
                        <th>Due Till Now</th>
                        <td className="text-right">
                          {this.props.sale?.due_till_now}
                        </td>
                      </tr>
                      <tr>
                        <th>Installments</th>
                        <td className="text-right">
                          {this.props.sale?.installments}
                        </td>
                      </tr>
                      <tr>
                        <th>Interest Rate</th>
                        <td className="text-right">
                          {this.props.sale?.interest_rate}
                        </td>
                      </tr>
                      <tr>
                        <th>Monthly Interest</th>
                        <td className="text-right">
                          {this.props.sale?.monthly_interest}
                        </td>
                      </tr>
                      <tr>
                        <th>Total Interest</th>
                        <td className="text-right">
                          {this.props.sale?.total_interest}
                        </td>
                      </tr>
                      <tr>
                        <th>Monthly Installment</th>
                        <td className="text-right">
                          {this.props.sale?.monthly_installment}
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  sale: state?.sale?.detail,
  saleId: Number(props?.match?.params?.id),
});

const mapDispatchToProps = dispatch => ({
  getSale: id => dispatch(SaleAction.getSale(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Detail);
